<!--
   Created by qing on 2020/12/21
   Des: 申请表单详情
-->
<template>

  <van-popup
    class="node-apply-detail-popup"
    v-model="visibleInfo.visible"
    :overlay="false"
    get-container="body"
    :style="{ height: '100%', width: '100%' }"
    @close="beforeClose"
    position="right">
    <div class="node-item-detail-popup-content">
      <div v-if="loadingEnd" class="node-item-detail-container">

        <div class="item-header">
          <div class="title-info">
            <div class="title">
              {{itemDetail.name}}
            </div>
            <van-icon name="delete" class="delete-button" @click="deleteItemInfo"/>
          </div>
          <div class="info">
            <div>
              <van-image
                style="width: 16px; height: 16px"
                :src="itemInfo.itemImage"
                fit="cover">
              </van-image>
              发起表单
            </div>
            <span>{{createUserName}}关联于{{actionFormatTime(itemInfo.createTime)}}</span>
          </div>
        </div>
        <div class="node-item-form-data-container">
          <Sectional
            v-for="(item, idx) in formSet.children"
            v-if="item.permission !== PERMISSION__HIDDEN"
            :key="item.dataId"
            :index="idx"
            :length="formSet.children.length"
            :type="formSet.status"
            :value="item">
          </Sectional>
        </div>

        <div style="margin-top: 10px; background-color: #fff">
          <comment-container
            ref="commentContainer"
            :commentList="commentList"
            :stackList="stackList"
            @replyComment="replyComment"
            @editComment="editComment"
            @onClickComment="onClickComment"
          ></comment-container>
        </div>
      </div>
      <div class="comment-input">
        <comment-input
          v-if="itemInfo"
          ref="commentInput"
          :nodeId="nodeId"
          :itemId="itemInfo.itemId"
          :mixFormId="mixFormId"
          commentType="ITEM"
          :fetchSourceContent="fetchSourceContent"
          @focusComment="focusComment"
          @submitCommentComplete="submitComment"
        ></comment-input>
      </div>

      <!--评论回复列表-->
      <CommentReplyList
        v-if="itemInfo"
        ref="commentReplyList"
        :nodeId="itemInfo.nodeId"
        :mixFormId="mixFormId"
        :stackList="stackList"
        commentType="NODE"
        @reply-close="replyListClose"
      ></CommentReplyList>
    </div>

  </van-popup>
</template>

<script>
  import {accurateFormatDate, fileType2FileImage, getSimpleText, clone} from "../../../assets/js/Untis";
  import CommentContainer from "./CommentContainer";
  import CommentInput from "./CommentInput";
  import CommentReplyList from "./CommentReplyList";
  import NodeAddAttachPopup from "./NodeAddAttachPopup";
  import {
    MIX_FORM_ITEM_TYPE_ATTACHMENT,
    MIX_FORM_ITEM_TYPE_IMAGE,
    MIX_FORM_ITEM_TYPE_MEMO,
    MIX_FORM_ITEM_TYPE_APPLY,
    MIX_FORM_ITEM_TYPE_DATA,
    MIX_FORM_ITEM_TYPE_VIEW,
    MIX_FORM_ITEM_TYPE_DASHBOARD, SUCCESS
  } from "../../store/types";
  import {ImagePreview} from 'vant'
  import RyFormSet from "../../RyForm";
  import {
    FORM_INSTANCE_NOT_EXIST,
    FORM_ITEM__CURRENT_VIEW_USER,
    FORM_STATUS__READ,
    FORM_TYPE__FILL,
    PERMISSION__HIDDEN
  } from "../../RyForm/types";
  import {FORM_VIEW_TYPE_DATA_HANDLE} from "../../../assets/types";

  export default {
    props: {
      mixFormInfo: Object,
      mixFormId: {
        type: String,
        default: ''
      },
      stackList: {
        type: Array,
        default: () => []
      }
    },
    components: {
      CommentContainer,
      CommentInput,
      CommentReplyList,
      NodeAddAttachPopup
    },
    data() {
      return {
        MIX_FORM_ITEM_TYPE_IMAGE,
        PERMISSION__HIDDEN,
        visibleInfo: {
          nodeId: '',
          visible: false
        },
        loadingEnd: false,
        nodeId: '',
        itemInfo: null,
        itemDetail: null,
        commentList: [],
        formSet: new RyFormSet(),
      }
    },
    created() {
    },
    computed: {
      createUserName() {
        const user = this.$store.getters.userListMap[this.itemInfo.userId]
        const extUser = this.$store.getters.extMap[this.itemInfo.userId]
        return user ? user.nickname : extUser ? extUser.orgUserName : ''
      },
    },
    methods: {
      actionFormatTime(d) {
        return accurateFormatDate(d)
      },
      actionFileType2FileImage(fileType) {
        return fileType2FileImage(fileType)
      },
      open({nodeId, itemId}) {
        this.loadingEnd = false
        this.nodeId = nodeId
        this.visibleInfo.nodeId = nodeId
        this.stackList.push(this.visibleInfo)
        this.visibleInfo.visible = true

        this.$store.dispatch('actionMixFormNodeItemDetail', {
          mixFormId: this.$route.params.mixFormId,
          nodeId: nodeId,
          itemId: itemId
        }).then(res => {
          this.itemInfo = res
          this.itemDetail = this.itemInfo.itemDetail
          this.fetchFormStructure()
          this.fetchCommentList()
        }).catch(console.error)
          .finally(() => {
            this.loadingEnd = true
          })

      },
      beforeClose() {
        if (this.$refs.commentInput) {
          this.$refs.commentInput.close()
        }
        if (this.$refs.commentReplyList) {
          this.$refs.commentReplyList.close()
        }
        this.$emit('close')
      },
      fetchFormStructure() {

        this.formSet.companyId = this.$store.getters.currentCompanyId
        this.formSet.userId = this.$store.getters.userId
        this.formSet.appId = this.itemDetail.appId
        this.formSet.formId = this.itemDetail.formId

        this.$store.dispatch('actionMergeStructure', {
          appId: this.itemDetail.appId,
          formId: this.itemDetail.formId,
          viewId: !this.itemDetail.viewId || this.itemDetail.viewId === FORM_VIEW_TYPE_DATA_HANDLE ? '' : this.itemDetail.viewId,
          formType: FORM_TYPE__FILL,
          viewType: !this.itemDetail.viewId || this.itemDetail.viewId === FORM_VIEW_TYPE_DATA_HANDLE ? 3 : 1,
          instanceId: this.itemDetail.instanceId,
          permissionFlag: 'TRUE'
        })
          .then(({status, resultObject, info}) => {
            if (status === SUCCESS) {
              return resultObject
            } else {
              throw new Error(`${status}: ${info}`)
            }
          })
          .then(({structureInfo, permissionInfo, detailInfo, pluginList, bothRelateList, displayList}) => {
            this.formSet.status = FORM_STATUS__READ

            this.formSet.setStructure(structureInfo)
            this.formSet.setPermission(permissionInfo.permissionList)
            this.formSet.setConf(detailInfo)
            this.formSet.setPlugin(pluginList)
            this.formSet.setBothRelate(bothRelateList)
            this.formSet.setDisplayRule(displayList)
            this.formSet.customFormStyle.mobileLayout = 'COMPACT'
            console.log('formSet', this.formSet)

            return this.getFormValues()
          })
          .then(() => {

            const currentUserField = []
            Object.values(this.formSet.fields).forEach(field => {
              if (field.type === FORM_ITEM__CURRENT_VIEW_USER) {
                currentUserField.push(field)
              }
            })
            if (currentUserField.length) {
              return this.$store.dispatch('actionMemberInfo', {
                companyId: this.formSet.companyId,
                userIdList: [this.$store.getters.userId]
              }).then(res => {
                if (res && Object.keys(res).length) {
                  currentUserField.forEach(field => {
                    const info = res[this.$store.getters.userId]
                    field.value.depart.push(...info.deptIdList)
                    field.value.role.push(...info.roleIdList)
                    field.value.externalTag.push(...info.tagList)
                  })
                }
                this.formSet.computeDisplayResults()
              })
            }
          })
          .then(() => {
            if (this.instanceId && this.formSet.hasRealTimeDataField()) {
              return this.$store.dispatch('actionFormRealTimeDataFieldData', {
                appId: this.formSet.appId,
                formId: this.formSet.formId,
                data: this.formSet.getValues()
              })
                .then(values => {
                  this.formSet.setValues(values)
                })
            }
          })
          .then(() => {
            this.formSet.isInit = true
          })
          .catch(err => {
            console.log(err)
          })
      },

      getFormValues() {
        const opts = {
          companyId: this.formSet.companyId,
          formId: this.formSet.formId,
          instanceId: this.itemDetail.instanceId,
          stepId: this.itemDetail.stepId
        }
        return this.$store.dispatch('actionFetchFormApplyDetail', opts)
          .then(({status, resultObject, info}) => {
            if (status === SUCCESS) {
              this.formSet.setValues(resultObject)
            } else if (status === FORM_INSTANCE_NOT_EXIST) {
              this.errorInfo = {
                code: status,
                info: '数据已删除。如有疑问请联系系统管理员'
              }
            } else {
              this.errorInfo = {
                code: status,
                info: '数据请求失败，请稍后重试'
              }
            }
          })
      },

      // 删除item
      deleteItemInfo() {
        if (this.mixFormInfo.archived) {
          this.$toast.fail(`该${this.$store.getters.mix_form_name}已归档，暂时无法操作，请启用后操作`)
          return
        }
        this.$dialog.confirm({
          title:'提示',
          message: '将会删除关联入口，但不会删除数据。是否删除？',
          confirmButtonText: '删除',
          cancelButtonText: '取消'
        }).then(() => {
          this.$store.dispatch('actionMixFormNodeItemDelete', {
            mixFormId: this.mixFormId,
            nodeId: this.nodeId,
            itemId: this.itemInfo.itemId,
          }).then(res => {
            this.$toast.success('删除成功')
            this.$emit('deleteNodeItemComplete', this.itemInfo.itemId)
            const visibleInfo = this.stackList.pop()
            visibleInfo.visible = false
          }).catch(console.error)

        }).catch(action => {
        })
      },

      fetchCommentList() {
        this.$store.dispatch('actionCommentList', {
          mixFormId: this.mixFormId,
          nodeId: this.nodeId,
          itemId: this.itemInfo.itemId,
          commentType: 'ITEM'
        }).then(res => {
          this.commentList = res
        }).catch(console.error)
      },

      // 获取回复的评论
      fetchSourceComment(commentId) {
        return this.commentList.filter(comment => comment.commentId === commentId)[0]
      },
      // 获取回复的评论的字符串内容
      fetchSourceContent(commentId) {
        const comment = this.fetchSourceComment(commentId)
        if (!comment) {
          return ''
        }
        let content = getSimpleText(comment.content)
        content += comment.content.includes('<img') ? '【图片】' : ''
        content += comment.content.includes('<video') ? '【视频】' : ''
        if (!content) {
          if (comment.attachmentList && comment.attachmentList.length) {
            content = '【附件】'
          }
        }
        return content
      },

      // 首次填写评论
      focusComment() {
        if (this.$refs.commentInput) {
          this.$refs.commentInput.open({
            commentStatus: 'NONE'
          })
        }
      },

      // 回复评论
      replyComment(item) {
        if (this.$refs.commentInput) {
          this.$refs.commentInput.open({
            commentStatus: 'REPLY',
            replyCommentInfo: item
          })
        }
      },
      // 编辑评论
      editComment(item) {
        if (this.$refs.commentInput) {
          this.$refs.commentInput.open({
            commentStatus: 'EDIT',
            commentInfo: clone(item)
          })
        }
      },
      // 点击评论
      onClickComment(item) {
        if (item.replyId && this.$refs.commentReplyList) {
          this.$refs.commentReplyList.open({
            commentId: item.commentId,
            rootId: item.rootId
          })
        }
      },
      // 发表评论完成
      submitComment({commentStatus, commentInfo}) {
        if (commentStatus === 'EDIT') {
          const comment = this.commentList.filter(comment => comment.commentId === commentInfo.commentId)[0]
          if (comment) {
            comment.content = commentInfo.content
            comment.attachmentList = commentInfo.attachmentList
          }
        } else {
          this.commentList.unshift(commentInfo)
        }
      },

      // 回复列表关闭，需要刷新一下评论列表
      replyListClose() {
        this.fetchCommentList()
      },
    }
  }
</script>

<style lang="less">

  .node-apply-detail-popup {
    background-color: #F6F6F6 !important;

    .node-item-detail-popup-content {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;

      .node-item-detail-container {
        position: absolute;
        top: 0;
        bottom: calc(50px + env(safe-area-inset-bottom));
        left: 0;
        right: 0;
        overflow: auto;

        .item-header {
          width: 100%;
          height: 80px;
          padding: 20px;
          background-color: #fff;
          border-bottom: 1px solid #e6e6e6;

          .title-info {
            display: flex;
            margin-bottom: 15px;

            .title {
              max-width: calc(100% - 40px);
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-wrap: break-word;
              margin-right: 10px;
            }

            .delete-button {
              color: red;
            }
          }
          > .info {
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #959699;

            > div {
              display: flex;
              align-items: center;
              color: #6d6d6d;
              margin-right: 20px;

              .van-image {
                margin-right: 5px;
              }
            }
          }
        }

        .node-item-form-data-container {
          .section-component__row-container {
            background-color: #F5F7FA !important;

            .van-cell__title {
              >span {
                font-size: 14px;
              }
            }

            .table-field-item {
              background-color: #F5F7FA !important;
            }
          }
        }
      }

      .comment-input {
        position: absolute;
        height: 50px;
        bottom: calc(env(safe-area-inset-bottom));
        left: 0;
        right: 0;
      }
    }

    .handle-button {
      font-size: 12px;
      color: #2D8cF0;
    }


    .file__list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      list-style: none;
      margin: 0;
      padding: 0;

      > li {
        list-style: none;
        width: calc(100% - 10px);
        min-height: 40px;
        margin: 5px;
        display: flex;
        position: relative;
        border-bottom: 1px solid #e6e6e6;


        > .file__icon {
          text-align: center;

          .icon {
            width: 30px;
            height: 30px;
            vertical-align: -0.15em;
            fill: currentColor;
            overflow: hidden;
            margin-right: 10px;
            margin-top: 5px;
          }
        }

        > .file__info {
          width: calc(100% - 40px);
          display: flex;
          flex-direction: column;

          > .file__info-name {
            line-height: 20px;
            color: #495060;
            font-size: 13px;
            width: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-wrap: break-word;
          }

          > .file__info-bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;

            > .file__info-size {
              height: 20px;
              line-height: 20px;
              font-size: 11px;
              color: #909399;
            }

            > .file__info-handle {
              display: flex;
              align-items: center;

              .divider {
                height: 16px;
                width: 1px;
                background-color: #e6e6e6;
                margin: 0 5px;
              }
            }
          }
        }
      }
    }
  }
</style>